
const CDANODATAMESSAGE = `Suggestions:|n|` +
                         `|t|-  Try a different time range.|n|` +
                         `|t|-  Try a related, but different dataset.|n|` +
                         `|t|-  Try a different variable.`;
const CDAUNKNOWNERRORMESSAGE = `Sorry, there was an error and the plot failed to generate.|n|`+
                         `Suggestions:|n|` +
                         `|t|-  Try a different time range.|n|` +
                         `|t|-  Try a related, but different dataset.|n|` +
                         `|t|-  Try a different variable.`;
const HELIOVIEWERNODATAMESSAGE = `Suggestions:|n|` +
                         `|t|-  Try a different time range.|n|`;
const CDATIMEERRORMESSAGE = 'Image format has been changed. Please re-plot!';
const CDAVARIABLEERROR = 'Please select at least one parameter!';
export const CDAERRORCODES = {
                            '001': ['Plot Action Failed', CDANODATAMESSAGE],
                            '002': ['Replot Required', CDATIMEERRORMESSAGE],
                            '003': ['Variable Required', CDAVARIABLEERROR],
                            '004': ['Time Error! ', 'Please set start time and end time!'],
                            '005': ['Time Error! ', 'Stop time cannot be less than or equal to start time!'],
                            '006': ['Download Action Failed', CDANODATAMESSAGE],
                            '007': ['CDAWeb Data ', 'No TimeInterval data returned from CDAWeb inventory.'],
                            '104': ['Failed to get variables from CDAWeb'],
                            '400': ['Bad Request' ],
                            '403': ['Authorization Error'],
                            '404': ['Not Found'],
                            '406': ['Not Acceptable'],
                            '415': ['Unsupported Media Type'],
                            '429': ['Too Many Requests'],
                            '503': ['Service Unavailable'],
                            '504': ['Service Timed Out'],
                            'Unknown': ['Unknown CDA Error' ,CDAUNKNOWNERRORMESSAGE]};

export const HELIOVIEWERERRORCODES = {
                            '001': ['Time Error', 'Future time is not valid.'],
                            '002': ['Time Error', 'Time is out of range.'],
                            '003': ['No Data', 'No wavelength data found.'],
                            '006': ['Download Action Failed', HELIOVIEWERNODATAMESSAGE],
                            '400': ['Bad Request' ],
                            '403': ['Authorization Error'],
                            '404': ['Not Found'],
                            '406': ['Not Acceptable'],
                            '415': ['Unsupported Media Type'],
                            '429': ['Too Many Requests'],
                            '503': ['Service Unavailable'],
                            'Unknown': ['Unknown Helioviewer Error' , 'Unknown Helioviewer Error']};

export const CDAWebDataType = {
  TEXT: 'text',
  IMAGE: 'image',
  AUDIO: 'audio'
};

export const CDAWebDataFileTypes = ['text','cdf', 'csv', 'nc'];
export const CDAWebAudioFileTypes = ['audio'];
export const CDAWEBORIGINURL = "https://cdaweb.gsfc.nasa.gov";
export const MAXIMUMTABS = 10;
export const TOUCHPOINTSID = "5b5cd587";
export const TOUCHPOINTSURL = `https://touchpoints.app.cloud.gov/touchpoints/${TOUCHPOINTSID}/submissions.json`;
export const GA_MEASUREMENT_ID = "_fed_an_ua_tag";
export const HELIOCLOUDS3LINK = "https://api.heliocloud.org/cloudcatalog";
